export default {
  title: {
    nl: 'Do you want an extra life?'
  },

  description: {
    nl: (price: number) =>
      `Buy an extra life for ${price} My McDonald's bonus points.`
  },

  balance: {
    nl: 'Your balance:'
  },

  submit: {
    nl: 'Buy extra life'
  },

  cancel: {
    nl: "No, I'll quit"
  }
};
